import { render, staticRenderFns } from "./WwvTw.vue?vue&type=template&id=2c81009e&"
import script from "./WwvTw.vue?vue&type=script&lang=js&"
export * from "./WwvTw.vue?vue&type=script&lang=js&"
import style0 from "./WwvTw.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/koen/co/sociare/werktijd_mobile/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VCheckbox,VContainer,VFlex,VForm,VLayout,VRadio,VRadioGroup,VTextarea})
